import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "@/App";
import { AuthProvider } from "@/providers/AuthProvider";
import { PreferencesProvider } from "@/providers/PreferencesProvider";
import "@/index.css";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 30_000,
            refetchOnWindowFocus: false,
            retry: 1,
        },
    },
});

const container = document.getElementById("root");
if (!container) throw new Error("Root container not found");

createRoot(container).render(
    <StrictMode>
        <QueryClientProvider client={queryClient}>
            <PreferencesProvider>
                <AuthProvider>
                    <App />
                </AuthProvider>
            </PreferencesProvider>
        </QueryClientProvider>
    </StrictMode>,
);
